import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue"
import { Applicant, ConsultantTalentFragmentFragment } from "@/gql"
import DocumentCard from "@/components/content/DocumentCard.vue"
import { useAuth } from "@/store/auth/useAuth"
import ProfileHeaderInfo from "@/components/profile/ProfileHeaderInfo.vue"
import { useCountry } from "@/hooks/useCountry"


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicantDetail',
  props: {
  applicant: {
    type: Object as PropType<Applicant | ConsultantTalentFragmentFragment>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const { user } = useAuth()

const { getCountryByName } = useCountry()



const getCountryFlag = (name?: string) => {
  if (!name) return
  return getCountryByName(name)?.flag
}

return { __sfc: true,user, getCountryByName, props, getCountryFlag, DocumentCard, ProfileHeaderInfo }
}

})